import { Injectable, Inject } from '@angular/core';
import { DVMService } from '../services/dvm.service';
import { GeneralHandler } from './general.handler';
import { DVM_CONFIG } from '../digitalvenue.configuration';
import { DVMConfiguration } from '../dvmconfiguration.model';
import { APIConnectionService } from '../services/api-connection.service';
import { FlowControlService } from '../services/flow-control.service';
import { PricingService } from '../services/pricing.service';
import { IsolatedSeatsApiService } from '../services/isolated-seats-api.service';

@Injectable()
export class LoadSeatselectionHandler extends GeneralHandler {
    constructor(@Inject(DVM_CONFIG) private dvmConfig: DVMConfiguration,
                private pricing: PricingService,
                private flowControl: FlowControlService,
                private connection: APIConnectionService,
                protected dvmService: DVMService,
                private isolatedSeats: IsolatedSeatsApiService) {
        super('end_load', dvmService);
    }

    loadBlockmapHandler(viewer) {
        viewer.setAvailability([]);
        this.connection.getPlanAvailability(this.flowControl.currentPlan, this.flowControl.upgradePlan).subscribe(
            planAvailability => {
                // tslint:disable-next-line: forin
                for (const areaId in planAvailability) {
                    this.pricing.areapricing[areaId] = {
                        min: planAvailability[areaId]['min_price'].toFixed(2),
                        max: planAvailability[areaId]['max_price'].toFixed(2)
                    };
                }
                viewer.setAvailable('section', Object.keys(planAvailability));
                viewer.setAvailable('section', Object.keys(this.flowControl.suitesHash));
                viewer.setNodesTag(Object.keys(this.flowControl.suitesHash), 'vip');
                viewer.setNodesTag(Object.keys(this.flowControl.greenSuites), 'vipGreen');
                // nuevo código de color para lexus y pr https://mmcbcn.atlassian.net/browse/MMC-12824?focusedCommentId=43753
                viewer.setNodesTag(Object.keys(this.flowControl.PRlexusHash), 'PRlexus');
                viewer.setNodesTag(Object.keys(this.flowControl.PRregularHash), 'PRregular');
                if (!this.flowControl.upgradePlan) {
                    this.connection.getPlanSeats(this.flowControl.currentPlan).subscribe(
                        basket => {
                            const basketArray = [];
                            for (const seat of basket) {
                                basketArray.push('S_' + seat['section']);
                            }
                            viewer.setNodesTag(basketArray, 'owned');
                        },
                        error => {
                            console.error(error.message);
                        }
                    );
                }
            },
            error => {
                console.error(error);
            });

    }

    loadSeatmapHandler(viewer) {
        viewer.setAvailability([]);
        this.connection.getPlanSectionAvailability(this.flowControl.currentPlan,
            viewer.getMapId(), this.flowControl.upgradePlan).subscribe(
            planSectionAvailability => {
                // gets the pending and discarded seats
                const pendingSeats = this.isolatedSeats.getPendingSeats();
                const discardedSeat = this.isolatedSeats.getDiscardedSeats();
                if (discardedSeat) {
                    Object.values(discardedSeat).forEach((seat => {
                        this.pricing.seatpricing[seat['id']] = {price: seat['price'],
                        price_type: seat['price_type_name']};
                    }));
                }

                // tslint:disable-next-line: forin
                for (const seatId in planSectionAvailability) {
                    this.pricing.seatpricing[seatId] = {price: planSectionAvailability[seatId].price_type.prices[0].price,
                    price_type: planSectionAvailability[seatId].price_type.name};
                }
                viewer.setAvailable('seat', Object.keys(planSectionAvailability));
                if (!this.flowControl.upgradePlan) {
                    this.connection.getPlanSeats(this.flowControl.currentPlan).subscribe(
                        basket => {
                            const basketArray = [];
                            // Crypto ask for not allow to select your discarded seats.
                            // https://mmcbcn.atlassian.net/browse/MMC-14826?focusedCommentId=74210
                            for (const seat of basket) {
                                basketArray.push(seat['id']);
                            }
                            viewer.setNodesTag(basketArray, 'owned');
                            // if (discardedSeat) {
                            //     viewer.setNodesTag(Object.keys(discardedSeat), null);
                            //     viewer.setAvailable('seat', Object.keys(discardedSeat));
                            // }
                            this.isolatedSeats.printIsolatedSeats(pendingSeats);
                        },
                        error => {
                            console.error(error.message);
                        }
                    );
                }
                for (const selectedSeat of Object.values(this.flowControl.Basket)) {
                    viewer.select(selectedSeat.id);
                }
            },
            error => {
                console.error(error);
            }
        );

    }

    protected handle(error, viewer) {
        if (error) { console.error(error); }
        viewer = viewer.instance;
        if (viewer.getMapId() === this.dvmConfig.map_id) {
            this.loadBlockmapHandler(viewer);
        } else {
            this.loadSeatmapHandler(viewer);
        }
    }
}
